const routes = {
  login: "/login",
  signup: "/signup",
  home: "/home",
  ainqa: "/ainqa",
  messageCatalog: "/messageCatalog"
};

export default routes;